import * as React from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import { Helmet } from "react-helmet";
interface IProps {
    closeButtonText?: any;
    onCloseCallback?: any;
    openAsDialog?: boolean;
    submitButtonText: string;
    onSubmitCallback: any;
    messageKey: string; // "credit-alert" | "FAM-alert" | "credit-service" | "credit-report" | "l3-timeout" | "l3-attempt-fail" | "idf-credit-service"
    continueFlowWithL3: boolean;
    diplayTimerMessage?: boolean;
}

const L3ContinueComponent: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();

    let blnDiplayTimerMessage = true;
    let authData = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.partnerProvider === "IDF"
        ) {
            return {
                isIDFUser: true,
            };
        }
        return { isIDFUser: "" };
    });
    let strSubmitButtonText = authData.isIDFUser ? "Verify My Identity" : "Try verification again";
    // set default value for props, if not passed
    if (props.diplayTimerMessage != null) {
        blnDiplayTimerMessage = props.diplayTimerMessage;
    }
    if (props.submitButtonText != null) {
        strSubmitButtonText = props.submitButtonText;
    }
    const  send_bb=()=> {
     var blackbox = ""; 
         try {
            blackbox = window.IGLOO.getBlackbox().blackbox;
       } catch (e) {} 
          return blackbox;
       }
    const header: any = {
        "credit-alert": tLang("dashboard.creditScore.l3ContinueComp.credit-alert"),
        "FAM-alert": tLang("dashboard.creditScore.l3ContinueComp.FAM-alert"),
        "credit-service": tLang("dashboard.creditScore.l3ContinueComp.credit-service"),
        "credit-report": tLang("dashboard.creditScore.l3ContinueComp.credit-report"),
        "l3-timeout": tLang("dashboard.creditScore.l3ContinueComp.l3-timeout"),
        "l3-attempt-fail": tLang("dashboard.creditScore.l3ContinueComp.l3-attempt-fail"),
        "idf-credit-service": tLang("credit.creditScore.creditScoreWidget.ssnAuthError.creditService.title"),
    };

    const getTimerMessage = () => {
        return <p>{parse(tLang("dashboard.creditScore.l3ContinueComp.timeConstraintText"))}</p>;
    };
    const prepareMessage = (messageKey: string) => {
        return (
            <div>
                <p>
                    {messageKey === "credit-alert" && tLang("dashboard.creditScore.l3ContinueComp.creditAlertMessage")}
                    {messageKey === "credit-service" && tLang("dashboard.creditScore.l3ContinueComp.creditServiceMessage")}
                    {messageKey === "credit-report" && tLang("dashboard.creditScore.l3ContinueComp.creditReportMessage")}
                    {messageKey === "FAM-alert" && tLang("dashboard.creditScore.l3ContinueComp.famAlertMessage")}
                    {props.continueFlowWithL3 && <>{tLang("dashboard.creditScore.l3ContinueComp.continueWithL3")}</>}
                </p>
                {props.continueFlowWithL3 && (
                    <>
                        <p>{tLang("dashboard.creditScore.l3ContinueComp.verifyIdentity")}</p>
                        {blnDiplayTimerMessage && getTimerMessage()}
                    </>
                )}
            </div>
        );
    };
    const message: any = {
        "credit-alert": prepareMessage("credit-alert"),
        "credit-service": prepareMessage("credit-service"),
        "credit-report": prepareMessage("credit-report"),
        "FAM-alert": prepareMessage("FAM-alert"),
        "l3-timeout": (
            <React.Fragment>
                <p>{tLang("dashboard.creditScore.l3ContinueComp.l3TimeoutDescription1")}</p>
                <p>{tLang("dashboard.creditScore.l3ContinueComp.l3TimeoutDescription2")}</p>
            </React.Fragment>
        ),
        "l3-attempt-fail": (
            <React.Fragment>
                <p>{tLang("dashboard.creditScore.l3ContinueComp.l3AttemptFail")}</p>
                {getTimerMessage()}
            </React.Fragment>
        ),
        "idf-credit-service": (
            <React.Fragment>
                <p>{tLang("credit.creditScore.creditScoreWidget.ssnAuthError.creditService.description")}</p>
            </React.Fragment>
        ),
    };

    //in case of dialog, register event for escape press
    if (props.openAsDialog != null && props.openAsDialog) {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                window.removeEventListener("keyup", () => {});
                onClose("cancel");
            }
        });
    }

    const invokePostSubmitCallback = (status: string, data: any,blackBoxKey: string) => {
        if (props.onSubmitCallback != null) {
            props.onSubmitCallback({ status: status, data: data ,BlackBoxKey: blackBoxKey});
        }
    };

    const onSubmit = () => {
        const blackBoxKey=send_bb();
        invokePostSubmitCallback("success", "continue", blackBoxKey);
    };

    const onClose = (reason?: string) => {
        // execute method passed as props for onCloseButtonClick
        if (props.onCloseCallback != null) {
            props.onCloseCallback({ reason: reason == null ? "close" : "cancel" });
        }
    };

    return (
        <React.Fragment>
            <div className="row" id="content">
                <div className="box col-xs-12">
                    <div className="dialog-header">
                        <h2 className="box-title">
                            <span className="dialog-icon status-default triangle-icon">
                                <em className="las la-exclamation-triangle"></em>
                            </span>
                            &nbsp;{header[props.messageKey]}
                        </h2>
                    </div>
                    <div className="dialog-body">
                        <div className="box-description">{message[props.messageKey]}</div>
                    </div>
                    <div className="dialog-footer">
                        <div className="row between-xs">
                            <div className="col-xs col-no-gutter flex-grow-null">
                                {props.closeButtonText && (
                                    <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => onClose()}>
                                        <span className="btn-text">{props.closeButtonText}</span>
                                    </button>
                                )}
                            </div>

                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="button" className="btn-default btn-primary" onClick={onSubmit}>
                                    <span className="btn-text">{strSubmitButtonText}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Helmet>
                <script src="js/config.js" type="text/javascript" />
                <script src="js/loader_only.js" type="text/javascript" />
            </Helmet>
        </React.Fragment>
    );
};

export default L3ContinueComponent;
